import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

import GoldMembershipItem from './GoldMembershipItem';
import styles from './GoldMembership.css';


const GoldMembership = (props) => {
  const {
    actions,
    children,
    footer,
    footerClass,
    header,
    headerClass,
    loading,
    memberships,
    rootClass,
  } = props;

  return (
    <div className={rootClass}>
      {header && (
        <header className={headerClass}>
          {header}
        </header>
      )}

      <div className={styles.loadingOverlay}>
        {loading && (
          <div className={styles.loadingBox}>
            <CircularProgress color="secondary" />
          </div>
        )}
        {children ? (
          children
        ) : (
          <ul className={styles.list}>
            {memberships.map((membership) => (
              <GoldMembershipItem
                key={membership.id}
                actions={actions}
                amount={membership.amount}
                currency={membership.currency}
                membership={membership}
                months={membership.months}
                price={membership.price}
                recurringPeriod={membership.recurringPeriod}
              />
            ))}
          </ul>
        )}
      </div>

      {footer && (
        <footer className={footerClass}>
          {footer}
        </footer>
      )}
    </div>
  );
};

GoldMembership.propTypes = {
  actions: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node,
  footerClass: PropTypes.string,
  header: PropTypes.node,
  headerClass: PropTypes.string,
  loading: PropTypes.bool,
  memberships: PropTypes.array,
  rootClass: PropTypes.string,
};

GoldMembership.defaultProps = {
  actions: undefined,
  children: null,
  footer: null,
  footerClass: undefined,
  header: null,
  headerClass: undefined,
  loading: false,
  memberships: [],
  rootClass: undefined,
};

export default GoldMembership;
